const MAILCHIMP_INTERNAL_URL = '/api/public-site/mailchimp';

const postMailchimpForm = async (form: { email: string; pathname: string }) => {
  const response = await fetch(MAILCHIMP_INTERNAL_URL, {
    method: 'POST',
    body: JSON.stringify(form),
  });
  if (response?.status === 201) {
    return response?.statusText || 'Form submitted';
  } else {
    throw new Error(`Request failed with status code ${response?.status}`);
  }
};

export const submitMailchimpForm = (email: string) => {
  return postMailchimpForm({
    email,
    pathname: window.location.pathname,
  });
};
